import strings from "./en";

/**
 * Look up a dotted key in the string catalogue, substituting `{name}`
 * placeholders.
 *
 * Kept out of `en.js` on purpose: that file is a pure catalogue whose shape
 * matches the one on `origin/echo-33-ex`, and mixing logic into it turns a
 * one-key merge into a whole-file conflict.
 *
 * No i18n library. The product ships in English only today, and pulling one in
 * to hold a few dozen strings would be weight without benefit. What this does
 * buy is the seam: copy lives in one reviewable file rather than scattered
 * through JSX, and adopting react-i18next later changes this function and
 * nothing else.
 *
 * Returns the key itself when nothing matches. A visible `onboarding.foo.bar`
 * in the UI is an obvious bug during review; an empty string silently renders
 * as a missing label nobody notices.
 *
 * @param {string} key
 * @param {Record<string, string|number>} [vars]
 */
export const t = (key, vars) => {
  const value = key
    .split(".")
    .reduce((node, part) => (node == null ? undefined : node[part]), strings);

  if (typeof value !== "string") return key;
  if (!vars) return value;

  return value.replace(/\{(\w+)\}/g, (match, name) =>
    name in vars ? String(vars[name]) : match,
  );
};

export default t;
